import { render, staticRenderFns } from "./Implant.vue?vue&type=template&id=961075ee&"
import script from "./Implant.vue?vue&type=script&lang=js&"
export * from "./Implant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports